import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class ReportsSchedulesRoute extends Route {
	@service('model-manager/reports') declare mmReportsService: Service.ModelManager.Reports;
	@service('model-manager/report-schedule-settings')
	declare mmReportScheduleSettingsService: Service.ModelManager.ReportScheduleSettings;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('billing') declare billingService: Service.Billing;

	override beforeModel(): Promise<unknown> {
		const promises: Promise<unknown>[] = [];
		promises.push(this.navigationService.initialRequestsPromise);
		promises.push(this.mmReportsService.requestReports());
		promises.push(this.mmReportScheduleSettingsService.requestReportSchedules());

		return Promise.all(promises);
	}

	override afterModel(): void {
		if (!this.billingService.reportsBasicEnabled) {
			this.navigationService.replaceRoute('reports.index');
		}
	}
}
